import { useState } from 'react';
import { apiService } from '../../services/api';
import PlusLogo from '../../assets/plusLogo.svg';
import { Button } from '../../components/Button';
import HttpsIcon from '@mui/icons-material/Https';
import { BoxForm } from '../../components/BoxForm';
import { Input } from '../../components/Inputs/Input';
import InputAdornment from '@mui/material/InputAdornment';
import { formRules } from '../../components/RegisterForm/FormRules';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { useToast } from '../../hooks';
import { ROUTES } from '../../utils/constants';

export interface IFormInput {
  password: string;
  confirmPassword: string;
}

export const NewPasswordPage = () => {
  const toast = useToast();
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);

  const userFormDefaultValues: IFormInput = {
    password: '',
    confirmPassword: '',
  };

  const methods = useForm<IFormInput>({
    defaultValues: userFormDefaultValues,
  });

  const { handleSubmit, reset } = methods;
  const navigate = useNavigate();
  const userId = searchParams.get('userId');
  const token = searchParams.get('token');

  const onSubmit: SubmitHandler<IFormInput> = async (data) => {
    if (!userId || !token) {
      toast.error('Link inválido!');
      return;
    }

    if (data.password !== data.confirmPassword) {
      toast.error('As senhas não conferem!');
      return;
    }

    setIsLoading(true);
    await apiService
      .resetPassword({ ...data, userId: Number(userId), token })
      .then(() => {
        toast.success('Senha alterada com sucesso!');
        reset();
        navigate(ROUTES.auth.login);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="flex justify-center items-center w-full h-screen">
      <FormProvider {...methods}>
        <BoxForm
          className="shadow-xl p-8 rounded-[2.81rem] overflow-hidden max-w-xl w-4/5"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <img
            className="flex self-center h-[16rem] w-[16rem]"
            src={PlusLogo}
            alt="logo"
          />
          <Input
            label="Senha"
            type="password"
            name="password"
            placeholder="******"
            rules={formRules.passwordRequired}
            startAdornment={
              <InputAdornment position="start">
                <HttpsIcon style={{ color: '#122B87' }} />
              </InputAdornment>
            }
          />
          <Input
            label="Confirme sua senha"
            type="password"
            name="confirmPassword"
            placeholder="******"
            rules={formRules.passwordRequired}
            startAdornment={
              <InputAdornment position="start">
                <HttpsIcon style={{ color: '#122B87' }} />
              </InputAdornment>
            }
          />
          <span className="text-center font-roboto font-bold text-gray-900">
            <Link
              className="text-blue-primary no-underline"
              to={ROUTES.auth.login}
            >
              Voltar a tela de login
            </Link>
          </span>
          <Button
            type="submit"
            style={{
              color: '#122B87',
              fontWeight: '800',
              textTransform: 'none',
              borderRadius: '25px',
              padding: '.3rem',
            }}
            isLoading={isLoading}
          >
            TROCAR SENHA
          </Button>
        </BoxForm>
      </FormProvider>
    </div>
  );
};
